export const environment = {
  production: true,
  apiEndPoint: "https://pay.smartie.com/api/",
  ADMIN_SERVICE: "https://pay.smartie.com/api/",
  AUTH_SERVICE: "https://pay.smartie.com/api/",
  socketUrl: "https://pay.smartie.com",
  baseGeoServiceUrl: "http://localhost",
  MEDIA_SERVICE: "https://media.pay.smartie.com/",
  FOOD_SERVICE: "https://pay.smartie.com/api/",
  TOUR_SERVICE: "https://pay.smartie.com/api/tours",
  AFFILIATE_BOOKING_URL: "https://tours.smartie.com/affiliate",
  APP_URL: "",
  firebase: {
    apiKey: "AIzaSyDhiwGC3bs2Y_jtWY8DP28H5UFmlVSnCgY",
    authDomain: "explorepay.firebaseapp.com",
    projectId: "explorepay",
    storageBucket: "explorepay.appspot.com",
    messagingSenderId: "81359603271",
    appId: "1:81359603271:web:130e2db8c8c6bdf2535362",
    measurementId: "G-HNZR139Q43",
  },
};
